import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatRp, formatDateID, waLink, discountAmount } from "@/lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { WhatsappLogo, Printer, Pill } from "@phosphor-icons/react";

function receiptText(d, obat = [], netObat = 0, kas = null) {
  const grand = Number(d.harga_final || 0) + Number(netObat || 0);
  const lines = [
    "*KWITANSI - GBS Clinic*",
    `Tanggal: ${formatDateID(d.tanggal_layanan || d.tanggal_kunjungan)}`,
    `Nama: ${d.nama_lengkap}`,
    `Layanan: ${d.jenis_layanan}`,
    d.petugas_nama ? `Petugas: ${d.petugas_nama}` : null,
    d.lokasi ? `Lokasi: ${d.lokasi}` : null,
    `Harga Normal: ${formatRp(d.harga_normal)}`,
    (discountAmount(d) > 0 ? `Diskon: -${formatRp(discountAmount(d))}` : null),
    (Number(d.potongan_lainnya) > 0 ? `Potongan: -${formatRp(d.potongan_lainnya)}` : null),
    `Subtotal Layanan: ${formatRp(d.harga_final)}`,
    ...(obat.length ? ["*Obat/Farmasi:*", ...obat.map((it) => `- ${it.nama} x${it.jumlah}: ${formatRp(it.subtotal - (it.harga_satuan * (it.returned_qty || 0)))}`), `Subtotal Obat: ${formatRp(netObat)}`, ...(kas ? [`Obat diterima: ${formatRp(kas.diterima - kas.dibatalkan)}`, `Refund obat: -${formatRp(kas.refund)}`, `Bayar obat bersih: ${formatRp(kas.bersih)}`, `Sisa obat: ${formatRp(kas.sisa)}`] : [])] : []),
    `*Total: ${formatRp(grand)}*`,
    `Pembayaran: ${d.metode_pembayaran || "-"} (${d.status_pembayaran || "-"})`,
    "Terima kasih 🙏",
  ];
  return lines.filter(Boolean).join("\n");
}

export default function Receipt({ tx, open, onClose }) {
  const d = tx;
  const [obat, setObat] = useState([]);
  const [netObat, setNetObat] = useState(0);
  const [kas, setKas] = useState(null);

  useEffect(() => {
    setObat([]); setNetObat(0);
    if (open && d?.id) {
      api.get(`/pharmacy/charges/reservation/${d.id}`)
        .then((res) => {
          const items = [];
          (res.data.charges || []).filter((c) => c.status !== "Void").forEach((c) => (c.items || []).forEach((it) => items.push(it)));
          setObat(items);
          setNetObat(Number(res.data.net_obat || 0));
          const k = res.data.kas_obat;
          setKas(k ? { ...k, sisa: Number(res.data.obat_belum_bayar || 0) } : null);
        })
        .catch(() => { setObat([]); setNetObat(0); });
    }
  }, [open, d?.id]);

  const grand = Number(d?.harga_final || 0) + Number(netObat || 0);
  const printReceipt = () => {
    const w = window.open("", "_blank", "width=380,height=600");
    if (!w || !d) return;
    const obatRows = obat.map((it) => {
      const net = it.subtotal - (it.harga_satuan * (it.returned_qty || 0));
      return `<div class="r"><span>${it.nama} ×${it.jumlah}</span><span>${formatRp(net)}</span></div>`;
    }).join("");
    w.document.write(`<html><head><title>Kwitansi</title><style>
      body{font-family:Arial;padding:16px;color:#333;max-width:320px}
      h2{text-align:center;margin:0;font-size:16px;color:#6A38C7}
      .c{text-align:center;font-size:12px;color:#888;margin-bottom:10px}
      .r{display:flex;justify-content:space-between;font-size:13px;padding:3px 0;border-bottom:1px dashed #eee}
      .sec{font-weight:bold;font-size:12px;margin-top:8px;color:#DB2777}
      .t{display:flex;justify-content:space-between;font-weight:bold;font-size:15px;margin-top:8px;color:#6A38C7}
      .f{text-align:center;margin-top:14px;font-size:12px;color:#888}
    </style></head><body>
      <h2>GBS Clinic</h2>
      <div class="c">KWITANSI PEMBAYARAN</div>
      <div class="r"><span>Tanggal</span><span>${formatDateID(d.tanggal_layanan || d.tanggal_kunjungan)}</span></div>
      <div class="r"><span>Nama</span><span>${d.nama_lengkap}</span></div>
      <div class="r"><span>Layanan</span><span>${d.jenis_layanan}</span></div>
      ${d.petugas_nama ? `<div class="r"><span>Petugas</span><span>${d.petugas_nama}</span></div>` : ""}
      ${d.lokasi ? `<div class="r"><span>Lokasi</span><span>${d.lokasi}</span></div>` : ""}
      <div class="r"><span>Harga Normal</span><span>${formatRp(d.harga_normal)}</span></div>
      ${discountAmount(d) > 0 ? `<div class="r"><span>Diskon</span><span>-${formatRp(discountAmount(d))}</span></div>` : ""}
      ${Number(d.potongan_lainnya) > 0 ? `<div class="r"><span>Potongan</span><span>-${formatRp(d.potongan_lainnya)}</span></div>` : ""}
      <div class="r"><span>Subtotal Layanan</span><span>${formatRp(d.harga_final)}</span></div>
      ${obat.length ? `<div class="sec">Obat / Farmasi</div>${obatRows}<div class="r"><span>Subtotal Obat</span><span>${formatRp(netObat)}</span></div>${kas ? `<div class="r"><span>Obat diterima</span><span>${formatRp(kas.diterima - kas.dibatalkan)}</span></div><div class="r"><span>Refund obat</span><span>-${formatRp(kas.refund)}</span></div><div class="r"><span>Bayar obat bersih</span><span>${formatRp(kas.bersih)}</span></div><div class="r"><span>Sisa obat</span><span>${formatRp(kas.sisa)}</span></div>` : ""}` : ""}
      <div class="t"><span>TOTAL</span><span>${formatRp(grand)}</span></div>
      <div class="r"><span>Pembayaran</span><span>${d.metode_pembayaran || "-"} (${d.status_pembayaran || "-"})</span></div>
      <div class="f">Terima kasih atas kunjungan Anda 🙏</div>
    </body></html>`);
    w.document.close(); w.focus(); w.print();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-2xl sm:max-w-sm" data-testid="receipt-dialog">
        {d && (
          <>
            <DialogHeader><DialogTitle className="font-heading">Kwitansi Pasien</DialogTitle></DialogHeader>
            <div className="rounded-xl border border-dashed border-rose-200 bg-[#F7F0FF] p-4 text-sm">
              <p className="text-center font-heading font-extrabold text-[#6A38C7]">GBS Clinic</p>
              <p className="mb-2 text-center text-xs text-slate-400">Kwitansi Pembayaran</p>
              {[["Tanggal", formatDateID(d.tanggal_layanan || d.tanggal_kunjungan)], ["Nama", d.nama_lengkap], ["Layanan", d.jenis_layanan], ["Petugas", d.petugas_nama || "-"], ...(d.pricing_mode === "per_item" ? [] : [["Harga Normal", formatRp(d.harga_normal)]]), ["Subtotal Layanan", formatRp(d.harga_final || d.total_tagihan || 0)]].map(([k, v]) => (
                <div key={k} className="flex justify-between border-b border-rose-100 py-1"><span className="text-slate-500">{k}</span><span className="font-semibold text-slate-700">{v}</span></div>
              ))}
              {obat.length > 0 && (
                <div className="mt-2" data-testid="receipt-obat">
                  <p className="mb-1 flex items-center gap-1 text-xs font-bold text-[#DB2777]"><Pill size={13} weight="duotone" /> Obat / Farmasi</p>
                  {obat.map((it, i) => {
                    const net = it.subtotal - (it.harga_satuan * (it.returned_qty || 0));
                    return <div key={i} className="flex justify-between border-b border-rose-50 py-1 text-xs"><span className="text-slate-500">{it.nama} ×{it.jumlah}{(it.returned_qty || 0) > 0 ? ` (retur ${it.returned_qty})` : ""}</span><span className="font-semibold text-slate-700">{formatRp(net)}</span></div>;
                  })}
                  <div className="flex justify-between py-1 text-xs font-bold"><span className="text-slate-600">Subtotal Obat</span><span className="text-slate-800">{formatRp(netObat)}</span></div>
                  {kas && <div className="text-[11px] text-slate-500" data-testid="receipt-obat-kas"><div className="flex justify-between"><span>Obat diterima</span><span>{formatRp(kas.diterima - kas.dibatalkan)}</span></div><div className="flex justify-between"><span>Refund obat</span><span>-{formatRp(kas.refund)}</span></div><div className="flex justify-between"><span>Bayar obat bersih</span><span>{formatRp(kas.bersih)}</span></div><div className="flex justify-between font-semibold"><span>Sisa obat</span><span data-testid="receipt-obat-sisa">{formatRp(kas.sisa)}</span></div></div>}
                </div>
              )}
              <div className="mt-2 flex justify-between font-heading text-lg font-extrabold text-[#6A38C7]"><span>TOTAL</span><span data-testid="receipt-grand-total">{formatRp(grand)}</span></div>
            </div>
            <div className="mt-3 flex gap-2">
              <button data-testid="receipt-print" onClick={printReceipt} className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-slate-800 py-2.5 text-sm font-bold text-white hover:bg-slate-900"><Printer size={18} weight="duotone" /> Print</button>
              <a data-testid="receipt-wa" href={waLink(d.no_whatsapp, receiptText(d, obat, netObat, kas))} target="_blank" rel="noreferrer" className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-[#25D366] py-2.5 text-sm font-bold text-white active:scale-95"><WhatsappLogo size={18} weight="fill" /> Kirim WA</a>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
